import { Box, useTheme } from "@mui/material";

import careSolutionsLogo from "../../assets/images/care-solutions-logo.png";
import careSolutionsLogoDark from "../../assets/images/care-solutions-logo-dark.png";

/** Supported logo heights: 22 (top bar), 30 (drawers), 46 (sign-in). */
export type BrandLogoHeight = 22 | 30 | 46;

export interface BrandLogoProps {
  /** Image height in px. Default 22. */
  height?: BrandLogoHeight;
}

/**
 * The Care Solutions wordmark. Dark mode uses a version with light lettering (the green
 * ring is unchanged), so the logo sits straight on the dark surface.
 */
export function BrandLogo({ height = 22 }: BrandLogoProps) {
  const theme = useTheme();
  const src =
    theme.palette.mode === "dark" ? careSolutionsLogoDark : careSolutionsLogo;

  return (
    <Box
      component="img"
      src={src}
      alt="Care Solutions"
      sx={{
        display: "block",
        height,
        width: "auto",
        maxWidth: "100%",
        objectFit: "contain",
        flex: "none",
      }}
    />
  );
}

export default BrandLogo;
